import { Box, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useParams, Link } from 'react-router-dom';
import url from '../../serverurl';

const transValue = (trans) => {
  return (Number(trans.price) * Number(trans.amount)).toFixed(5);
};

const getBLockNumber = (id) => {
  return parseInt(id) + 6000000;
};

export default function TransactionTX() {
  const { hash } = useParams();
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const res = await fetch(`${url}/blockchain/txn/${hash}`);
        const data = await res.json();
        setTransaction(data[0]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTransaction();
  }, [hash]);

  if (loading) {
    return (
      <Box>
        <Navbar />
        <section className="term-detail-page">
          <div className="container">
            <div className="term-detail-loading">
              <CircularProgress sx={{ color: 'var(--term-amber)' }} size={20} />
              <span>LOADING TRANSACTION...</span>
            </div>
          </div>
        </section>
        <Footer />
      </Box>
    );
  }

  if (!transaction) {
    return (
      <Box>
        <Navbar />
        <section className="term-detail-page">
          <div className="container">
            <div className="term-detail-empty">▸ TRANSACTION NOT FOUND</div>
          </div>
        </section>
        <Footer />
      </Box>
    );
  }

  return (
    <Box>
      <Navbar />
      <section className="term-detail-page">
        <div className="container">

          {/* Header */}
          <div className="term-detail-header">
            <div className="term-detail-crumb">
              <Link to="/">HOME</Link>
              <span>/</span>
              <span>TRANSACTIONS</span>
              <span>/</span>
              <span className="term-detail-crumb-active">{transaction?.hash?.slice(0, 12)}…</span>
            </div>
            <div className="term-detail-title-row">
              <h1 className="term-detail-title">▸ TRANSACTION DETAILS</h1>
              <span className="term-status">
                <span className="term-dot"></span>SUCCESS
              </span>
            </div>
          </div>

          {/* Summary cards */}
          <div className="term-detail-summary">
            <div className="term-summary-card">
              <div className="term-summary-lbl">VALUE</div>
              <div className="term-summary-val term-summary-amber">${transValue(transaction)}</div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">BLOCK</div>
              <div className="term-summary-val">
                {transaction?.block && getBLockNumber(transaction.block)}
              </div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">TYPE</div>
              <div className="term-summary-val">
                {transaction?.trans_type === "default" ? "Transfer" : "Swap"}
              </div>
            </div>
            <div className="term-summary-card">
              <div className="term-summary-lbl">SYMBOL</div>
              <div className="term-summary-val">
                {transaction?.origin?.toLowerCase() === "hootdex" ? transaction.symbol : "PECU"}
              </div>
            </div>
          </div>

          {/* Detail panel */}
          <div className="term-detail-panel">
            <div className="term-detail-panel-head">
              <span className="term-panel-title">▸ TRANSACTION DATA</span>
            </div>

            <div className="term-detail-rows">

              <div className="term-detail-row">
                <div className="term-detail-lbl">Transaction Hash</div>
                <div className="term-detail-val term-addr">{transaction?.hash}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Status</div>
                <div className="term-detail-val">
                  <span className="successButton">
                    <i><CheckCircleIcon /></i>
                    Success
                  </span>
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">From</div>
                <div className="term-detail-val term-addr">{transaction?.sender}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">To</div>
                <div className="term-detail-val term-addr">{transaction?.recipient}</div>
              </div>

              <div className="term-detail-divider" />

              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Height</div>
                <div className="term-detail-val">
                  {transaction?.block && getBLockNumber(transaction.block)}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Size</div>
                <div className="term-detail-val">128 bytes</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Timestamp</div>
                <div className="term-detail-val">
                  <i><AccessTimeIcon sx={{ fontSize: 14, mr: 0.5 }} /></i>
                  {new Date(transaction?.timestamp).toUTCString()}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Node</div>
                <div className="term-detail-val">{transaction?.node}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Route</div>
                <div className="term-detail-val">{transaction?.route}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Value</div>
                <div className="term-detail-val term-amount">{transValue(transaction)} USD</div>
              </div>

              <div className="term-detail-divider" />

              <div className="term-detail-row">
                <div className="term-detail-lbl">Trans Type</div>
                <div className="term-detail-val">
                  {transaction?.trans_type === "default" ? "Transfer" : "Swap"}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Origination</div>
                <div className="term-detail-val">
                  {transaction?.trans_type === "default" ? "PecuNovus Terminal" : "HootDex"}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Symbol</div>
                <div className="term-detail-val">
                  {transaction?.origin?.toLowerCase() === "hootdex"
                    ? <a href={`https://app.hootdex.net/${transaction.symbol}`} target="_blank" rel="noreferrer" className="term-link">{transaction.symbol}</a>
                    : "PECU"}
                </div>
              </div>

              <div className="term-detail-divider" />

              <div className="term-detail-row">
                <div className="term-detail-lbl">Block Address</div>
                <div className="term-detail-val term-addr">{transaction?.key}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Contract Key</div>
                <div className="term-detail-val term-addr">{transaction?.contractKey}</div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Public Notes</div>
                <div className="term-detail-val">
                  {transaction?.publicNote || <span className="term-detail-empty-inline">—</span>}
                </div>
              </div>

              <div className="term-detail-row">
                <div className="term-detail-lbl">Private Notes</div>
                <div className="term-detail-val">
                  {transaction?.privateNote || <span className="term-detail-empty-inline">—</span>}
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>
      <Footer />
    </Box>
  );
}